import { usePortfolioFlowLayout } from './PortfolioProcessLayoutManager';

export const usePortfolioProcessLayoutActions = () => {
    const { actions } = usePortfolioFlowLayout();

    return actions;
};
